import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { DishesContext, IDishesContext } from '../../dishesState/dishesContext';
import List from './components/List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Dishes.module.scss';

const Dishes: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, dishes, currentPage, countOfItems } = useContext<IDishesContext>(DishesContext);

	return (
		<>
			{dishes.dishesCount ? (
				<div className={style.container} data-test="Dishes">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={dishes.dishesCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default Dishes;
